import { gpsTable } from "./gpsScore";

export const sectionsText = {
  collaboration: ["Converse instead of just communicating; give the congregation enough avenues to speak and be heard throughout the week.", "Evaluate if your congregation is on board with your vision and mission because you can collaborate only with those on the same page.", "Collaborate with at least one new church in your city every year to serve your local community."],
  positioning: ["Research who needs your church more than you need them and why they will drive past many other churches to worship with you on the weekend.", "Ask and understand which brand and venue is the current heart of your community so that your church can aim to be that in the future.", "Survey how your community likes to learn, listen, and be loved so that you can connect, communicate, and church with them accordingly."],
  preparation: ["Assess your church's current volunteering capacity and identify their honest motivation levels to learn who wants to serve and how you can help.", "Invite members who joined the church recently to a discovery session to understand how you could have welcomed them better on day one.", "Reach out to first-time visitors who filled out the welcome card but never returned so that you can identify those hurdles and remove them."],
  engagement: ["Identify the most popular local brand; get in touch with them to understand how they got there and check collaboration potential.", "Talk to your congregation to see if they are truly engaged during the weekend services and ask what can help increase that further.", "Survey your community event attendees to see if they are truly engaged during such engagement opportunities and ask what can help increase that further."],
  outcomes: ["Work with mayors and local leaders of surrounding cities to see if your church and its programs can serve your communities even better.", "Survey your leadership team for honest feedback on whether your church's community engagement efforts are worth the investment.", "Ask and understand why congregants aren't inviting friends and neighbors to your engagement opportunities so you can plug the gaps."],
  sameScores: ["Evaluate if your congregation is on board with your vision and mission; you can collaborate only with those on the same page.", "Survey how your community likes to learn, listen, and be loved; connect, and communicate with them accordingly.", "Interview members who joined the church recently to understand how you could have welcomed them better on day one.", "Get in touch with the most popular local brand to understand how they got there and check collaboration potential.", "Work with local leaders of surrounding cities to see if your church and its programs can serve your communities even better."],
};

export const getMindsetSum = (variables) => {
  if (!Array.isArray(variables)) return 0;

  const mindsetVars = [
    "mind_set1", "mind_set2", "mind_set3", "mind_set4",
    "mind_set5", "mind_set6", "mind_set7", "mind_set8",
    "mind_set9", "mind_set10", "mind_set11", "mind_set12"
  ];

  let mindsetSum = 0;
  const mindSetSumVar = variables.find(v => v.variable === "mind_set_sum");

  if (mindSetSumVar && mindSetSumVar.score !== undefined) {
    mindsetSum = mindSetSumVar.score;
  } else {
    mindsetSum = mindsetVars.reduce((sum, mindsetVar) => {
      const variable = variables.find(v => v.variable?.trim() === mindsetVar);
      return sum + (variable && variable.score !== undefined ? variable.score : 0);
    }, 0);
  }

  return mindsetSum;
};


export const categorizeMindset = (percentage) => {
  if (percentage < 36) {
    return "fixed";
  } else if (percentage >= 36 && percentage < 66) {
    return "conditional";
  } else {
    return "growth";
  }
};

export const getPercentileFromScore = (totalScore, table = gpsTable) => {
  const score = Math.round(Number(totalScore - 12))
  const min = table[0]
  const max = table[table.length - 1]

  if (score <= min.score) return 0
  if (score >= max.score) return 100

  const exact = table.find((row) => row.score === score)
  if (exact) return exact.percentile

  const nearest = table.reduce((a, b) => {
    const d1 = Math.abs(a.score - score)
    const d2 = Math.abs(b.score - score)
    return d2 < d1 ? b : a
  })
  return nearest.percentile
}